(function ($) {

    $("#button-page-pld-alumni").on('click', function() {
        var $section = $("#alumni-perks");
        if ($section.length > 0) {
            $('html,body').animate({scrollTop: $section.offset().top - 120}, 'slow');
        }
    });
   
    
})(jQuery);
